/* Back to the Office: product-page ink sections */
(function () {
  if (window.__btfPI) return; window.__btfPI = true;
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- compatible supplies on printer pages ---------- */
  function initSupplies(root) {
    var initial = parseInt(root.getAttribute('data-initial'), 10) || 10;
    if (window.matchMedia && matchMedia('(max-width: 749px)').matches) initial = Math.min(initial, 6);
    var cards = [].slice.call(root.querySelectorAll('.btf-pi__card'));
    var moreWrap = root.querySelector('.btf-pi__more');
    var expanded = false, filter = 'all';
    function apply() {
      var shown = 0, matching = 0;
      cards.forEach(function (c) {
        var ok = filter === 'all' || (filter.indexOf('o:') === 0 ? c.getAttribute('data-o') === filter.slice(2) : c.getAttribute('data-t') === filter.slice(2));
        if (ok) matching++;
        var vis = ok && (expanded || shown < initial);
        if (vis) shown++;
        c.hidden = !vis;
      });
      moreWrap.hidden = expanded || matching <= initial;
    }
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-pi-filter]');
      if (chip) {
        filter = chip.getAttribute('data-pi-filter');
        root.querySelectorAll('[data-pi-filter]').forEach(function (b) { var on = b === chip; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply(); return;
      }
      if (e.target.closest('[data-pi-more]')) { expanded = true; apply(); }
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-pi-add]'); if (!form) return;
      e.preventDefault(); addToCart(form, root);
    });
    apply();
  }

  function addToCart(form, root) {
    var btn = form.querySelector('button'), label = btn.textContent;
    var id = parseInt(form.querySelector('[name=id]').value, 10);
    btn.disabled = true; btn.textContent = 'Adding\u2026';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, .header__cart-count, [data-header-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:change'].forEach(function (ev) {
          try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: { cart: cart } })); } catch (err) {}
        });
        try { if (window.Station && Station.Theme && Station.Theme.Cart && Station.Theme.Cart.init) Station.Theme.Cart.init(); } catch (err) {}
        toast(root, 'Added to your basket', true);
      })
      .catch(function () { toast(root, 'Sorry, that item couldn\u2019t be added. Please try again.', false); })
      .then(function () { btn.disabled = false; btn.textContent = label; });
  }
  var tt;
  function toast(root, msg, link) {
    var t = root.querySelector('.btf-pi__toast'); if (!t) return;
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (link ? '<a href="/cart">View basket</a>' : '');
    t.classList.add('is-show'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('is-show'); }, 4000);
  }

  /* ---------- fits these printers on supply pages ---------- */
  function initFits(root) {
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 18;
    var finder = root.getAttribute('data-finder') || '/pages/ink-finder';
    var groups = [].slice.call(root.querySelectorAll('[data-pi-group]'));
    var items = [].slice.call(root.querySelectorAll('[data-pi-model]'));
    var moreWrap = root.querySelector('.btf-pi__more');
    items.forEach(function (li) { li._n = norm(li.getAttribute('data-pi-model')); li._c = norm(li.textContent); });
    function collapse(on) {
      var n = 0;
      items.forEach(function (li) { li.hidden = on && n >= limit; n++; });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-pi-model]:not([hidden])'); });
      if (moreWrap) moreWrap.hidden = !on || items.length <= limit;
    }
    collapse(true);
    var more = root.querySelector('[data-pi-fits-more]');
    if (more) more.addEventListener('click', function () { collapse(false); });

    var form = root.querySelector('[data-pi-check]');
    if (!form) return;
    var input = form.querySelector('[data-pi-q]'), out = form.querySelector('[data-pi-result]');
    function check(final) {
      var q = norm(input.value);
      items.forEach(function (li) { var m = li.querySelector('.btf-pi__model'); if (m) m.classList.remove('is-hit'); });
      if (q.length < 2) { out.hidden = true; collapse(true); return; }
      var hits = items.filter(function (li) { return li._c === q || li._n.slice(-q.length) === q || li._c.indexOf(q) === 0; });
      if (!hits.length && q.length >= 3) hits = items.filter(function (li) { return li._n.indexOf(q) > -1; });
      if (hits.length) {
        collapse(false);
        hits.forEach(function (li) { li.querySelector('.btf-pi__model').classList.add('is-hit'); });
        var name = hits[0].getAttribute('data-pi-model').replace(/\s+/g, ' ').trim();
        out.className = 'btf-pi__result is-yes'; out.hidden = false;
        out.innerHTML = hits.length === 1 ? '<strong>Yes, this fits.</strong> ' + esc(name) + ' is on the list.' : '<strong>Yes, this fits.</strong> ' + hits.length + ' matching models are highlighted below.';
        if (final) { var first = hits[0]; first.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      } else if (final) {
        out.className = 'btf-pi__result is-no'; out.hidden = false;
        out.innerHTML = 'We can\u2019t see <strong>' + esc(input.value) + '</strong> on the list for this cartridge. <a href="' + esc(finder) + '?q=' + encodeURIComponent(input.value) + '">Find the right ink for your printer</a>.';
      } else { out.hidden = true; }
    }
    input.addEventListener('input', function () { check(false); });
    form.addEventListener('submit', function (e) { e.preventDefault(); check(true); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-btf-pi]').forEach(function (r) { if (!r._pi) { r._pi = 1; initSupplies(r); } });
    (scope || document).querySelectorAll('[data-btf-fits]').forEach(function (r) { if (!r._pi) { r._pi = 1; initFits(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
